// The messenger is mounted under /_ on the site (/chats -> /_/chats). Router paths stay the messenger's
// own; anything that reads or builds a real browser URL goes through these two.
export const HAMI_MOUNT = "/_";

export function toBrowserPath(routerPath) {
  const p = routerPath.startsWith("/") ? routerPath : `/${routerPath}`;
  return `${HAMI_MOUNT}${p}`;
}

export function fromBrowserPath(pathname) {
  if (pathname === HAMI_MOUNT) return "/";
  return pathname.startsWith(`${HAMI_MOUNT}/`) ? pathname.slice(HAMI_MOUNT.length) : pathname;
}
